const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatDateValue(val: string | number | null | undefined): string {
  if (!val) return '';
  const str = String(val).trim();
  if (!str) return '';

  const bc = str.startsWith('-');
  const digits = bc ? str.slice(1) : str;

  if (digits.length === 4) {
    return digits + (bc ? ' BC' : '');
  }
  if (digits.length === 6) {
    const year = digits.slice(0, 4);
    const month = parseInt(digits.slice(4, 6), 10);
    const monthName = MONTHS[month - 1] || '??';
    return `${monthName} ${year}${bc ? ' BC' : ''}`;
  }
  if (digits.length === 8) {
    const year = digits.slice(0, 4);
    const month = parseInt(digits.slice(4, 6), 10);
    const day = parseInt(digits.slice(6, 8), 10);
    const monthName = MONTHS[month - 1] || '??';
    return `${monthName} ${day}, ${year}${bc ? ' BC' : ''}`;
  }
  return str;
}

export function isValidDateValue(val: string | number | null | undefined): boolean {
  if (!val || !String(val).trim()) return true;
  return /^-?\d{4}(\d{2}(\d{2})?)?$/.test(String(val).trim());
}
